export const FormSamplesBasicPageInfo = () => {
    return (
        <>
            This shows the basic usage of how to use forms. Take note of the following:
            <ul>
                <li>
                    Your main app component needs to be wrapped in a SisLibraryProviders context.
                    See Forms/About for more information.
                </li>
                <li>
                    Define an interface for your form to use.
                    It is best to:
                    <ul>
                        <li>Create an interface at the top of the component that has the form in it,</li>
                        <li>Call this interface with a single letter. (like T)</li>
                        <li>Extend this interface to an existing interface in your project</li>
                    </ul>
                    If the interface you are extending has all the required fields needed for your form, it's still best to create a new
                    interface in this component with a single letter that extends that interface.<br />
                    This will ensure that:
                    <ul>
                        <li>Later you can extend just the form interface if you need to without changing the
                            original interface.</li>
                        <li>Having the interface defined as a single letter (like T) makes the code easier to read.</li>
                        <li>If copying and pasting code from another component typescript will ensure you change
                            the fieldname if the copying field isn't defined in this components interface you are extending.</li>
                    </ul>
                </li>
                <li>There is no need to use uneccessary boilder plate code
                    like keeping state for each form value, defining an onClick or onChange for every field, or setting every fields value.
                    This is all done within the component.</li>
                <li>The context provider holds information for multiple forms, so a form name needs to be specified and needs to be unique.</li>
            </ul>
            Source code location:<br />
            <i>'src/components/formSamples/formSamplesPages/formSamplesBasicPage'</i>
        </>
    )
}
